import { render, staticRenderFns } from "./WinLottery.vue?vue&type=template&id=0622190c&scoped=true&"
import script from "./WinLottery.vue?vue&type=script&lang=ts&"
export * from "./WinLottery.vue?vue&type=script&lang=ts&"
import style0 from "./WinLottery.vue?vue&type=style&index=0&id=0622190c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622190c",
  null
  
)

export default component.exports